module.exports = __webpack_public_path__ + "static/media/burgers.06ee76a9.jpeg";